import { Button, Stack, Typography } from '@mui/material'
import React from 'react'

import { StyledRouterLink } from 'components/common/StyledRouterLink'
import TrackedExternalLink from 'components/common/TrackedExternalLink'
import Icon from 'components/Icon'
import { getTestSuitesUrls } from 'components/test-suites/test-suites-urls-utils'
import { getCanCreateAndEditTestSuites } from 'components/test-suites/test-suites-utils'
import useAuth from 'hooks/use-auth'
import { useTranslation } from 'hooks/use-translation'
import theme from 'theme'

export const TestSuitesHeader: React.FC = () => {
  const { hasEndpointAccess } = useAuth()
  const testSuitesUrls = getTestSuitesUrls()

  const canCreateAndEditTestSuites =
    getCanCreateAndEditTestSuites(hasEndpointAccess)

  const { trans } = useTranslation()

  return (
    <Stack
      alignItems="flex-start"
      direction="row"
      gap={5}
      justifyContent="space-between"
    >
      <Stack
        alignItems="flex-start" // important - ensures StyledRouterLink doesn't take up sibling's height
        gap={2}
      >
        <Typography data-test-test-suites-header variant="h5">
          {trans('test_suites')}
        </Typography>
        <Typography data-test-test-suites-header-text variant="body1">
          {trans('test_suites.description')}{' '}
          <TrackedExternalLink href="https://www.gremlin.com/docs/reliability-management/test-suites/">
            {trans('test_suites.learn_more')}{' '}
            <Icon
              css={{ height: theme.fontSizes[0] }}
              icon="arrowUpRightFromSquare"
            />
          </TrackedExternalLink>
        </Typography>
      </Stack>
      {canCreateAndEditTestSuites && (
        <Button
          data-test-test-suites-header-button
          component={StyledRouterLink}
          css={{
            minWidth: 'min-content' // stop button from collapsing
          }}
          startIcon={<Icon icon="plus" />}
          state={{}}
          to={testSuitesUrls.new()}
          variant="contained"
        >
          {trans('test_suite')}
        </Button>
      )}
    </Stack>
  )
}
